<template>
    <div class="cms-content-slice-stock-list__item">
        <div class="cms-content-slice-stock-list__item--image">
            <picture>
                <source :srcset="imageWebp" type="image/webp">
                <img class="img-responsive" :src="imagePng" :alt="vehicle.model" loading="lazy">
            </picture>
        </div>
        <div class="cms-content-slice-stock-list__item--brand">{{ vehicle.brand }}</div>
        <div class="cms-content-slice-stock-list__item--model">{{ vehicle.model }}</div>
        <div class="cms-content-slice-stock-list__item--colour"><span class="cms-content-slice-stock-list__item-label">Colour: </span>{{ vehicle.colour }}</div>
        <div class="cms-content-slice-stock-list__item--deposit"><span class="cms-content-slice-stock-list__item-label" v-if="displayGrant">Deposit Contribution: </span>{{ displayGrant }}</div>
        <div class="cms-content-slice-stock-list__item--price"><span class="cms-content-slice-stock-list__item-label">Price: </span>{{ displayPrice }}</div>
        <div class="cms-content-slice-stock-list__item--button">
            <button @click="enquireNow" type="button" class="btn btn--primary" v-if="!vehicle.reserved_at">Enquire Now</button>
            <button type="button" class="btn btn--primary btn--disabled" disabled v-else>Reserved</button>
        </div>
    </div>
</template>

<script>
import { customEvent } from '../../../modules/tracking/AnalyticsEvents';

export default {
    props: ['vehicle'],
    computed: {
        imageWebp() {
            return 'https://cdn.imagin.studio/getImage?customer=robinsandday&' + this.vehicle.url_identifier + '&fileType=webp&zoomType=fullscreen&steering=right&width=400&angle=01';
        },
        imagePng() {
            return 'https://cdn.imagin.studio/getImage?customer=robinsandday&' + this.vehicle.url_identifier + '&fileType=jpg&zoomType=fullscreen&steering=right&width=400&angle=01';
        },
        displayGrant() {
            return this.vehicle.grant ? Number(this.vehicle.grant).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';
        },
        displayPrice() {
            return this.vehicle.price ? Number(this.vehicle.price).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';
        },
    },
    methods:{
        enquireNow() {
            if (this.vehicle.reserved_at) {
                console.log('already reserved');
                return;
            }
            customEvent('New Car - Stock Page', 'Enquire Now CTA', 'Clicked');
            this.$store.dispatch('enquireNow', this.vehicle)
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/stock-list/StockListRow.vue